import React from 'react';
import { resolveMaterialImage } from '../../utils/materialCatalog';

/**
 * Renders a tag product photo with clip ring anchored toward the top of the frame.
 */
const TagMaterialImage = ({ src, alt, className = '' }) => {
  const resolvedSrc = resolveMaterialImage(src);
  if (!resolvedSrc) return null;

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={`max-w-full max-h-full object-contain object-top dark:brightness-110 dark:contrast-105 ${className}`.trim()}
    />
  );
};

export default TagMaterialImage;
